import { createFileRoute, redirect } from '@tanstack/react-router';
import { ApiError } from '../api/client';
import { meQuery, resultsQuery } from '../api/queries';
import { AppShell } from '../features/shell/AppShell';
import { contentQuery } from '../lib/content';
import { currentLang } from '../lib/i18n';
import { RouteError } from '../ui/States';

/** Every signed-in page. Loads who you are, your results and the content before rendering. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.query({ ...meQuery, staleTime: 'static' });
    } catch (error) {
      if (error instanceof ApiError && error.code === 'UNAUTHENTICATED') {
        throw redirect({ to: '/login', search: { returnTo: location.pathname } });
      }
      throw error;
    }
  },
  loader: async ({ context }) => {
    const profile = await context.queryClient.query({ ...resultsQuery, staleTime: 'static' });
    await context.queryClient.query({
      ...contentQuery(profile.contentVersion, currentLang()),
      staleTime: 'static',
    });
  },
  component: AppShell,
  errorComponent: RouteError,
});
